import { render, staticRenderFns } from "./HotProducts.vue?vue&type=template&id=5c42dc74"
import script from "./HotProducts.vue?vue&type=script&lang=js"
export * from "./HotProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MinProducts: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/MinProducts.vue').default})
